import {Cart, LineItem} from '@wix/auto_sdk_ecom_current-cart';

export class CartModel {
  public id?: string;
  public itemsCount?: number;

  constructor(params: CartModel) {
    this.id = params.id;
    this.itemsCount = params.itemsCount;
  }

  public static fromSDK(cart: Cart): CartModel {
    return new CartModel({
      id: cart?._id ?? undefined,
      itemsCount: cart?.lineItems ? calculateItemsCount(cart?.lineItems) : undefined,
    });
  }
}

function calculateItemsCount(items: Partial<LineItem>[]): number | undefined {
  return items.reduce((total, lineItem) => {
    const {availability, quantity} = lineItem;
    const itemCount =
      availability?.quantityAvailable !== undefined
        ? Math.min(
            availability.quantityAvailable ?? /* istanbul ignore next: todo: missing test */ 0,
            quantity ?? /* istanbul ignore next: todo: missing test */ 0
          )
        : quantity ?? /* istanbul ignore next: todo: missing test */ 0;

    return total + (itemCount || 0);
  }, 0);
}
